<app-header></app-header>
 
<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one" id="home">
    <ng-template carouselSlide *ngFor="let slide of slideStore">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-dark-05 main-hero-section" style="background-image: url('{{slide.image}}')">
            <div class="bg-dark-05">
                <div class="container">
                    <div class="position-middle">
                        <div class="row">
                            <div class="col-12">
                                <h1 class="display-5 fw-black uppercase">{{slide.title}}</h1>
                                <h2 class="display-4 fw-medium uppercase">{{slide.subtitle}}</h2>
                                <h1 class="display-5 fw-black uppercase">{{slide.subtitleTwo}}</h1>
                                <a class="button button-lg button-radius button-gradient-1 mt-3" routerLink="/about-us">Read more</a>
                            </div>
                        </div><!-- end row -->
                        
                    </div><!-- end row -->
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->

<!-- About section -->
<div class="section">
    <div class="container">
        <div class="row align-items-center mr-0">
            <div class="col-12 col-lg-6 col-xl-6 pd-0">
                <img src="assets/images/about/intro-img.png" alt="about-img">
            </div>
            <div class="col-12 col-lg-6 col-xl-6 pd-60 heading-style-one">
                <hr class="gradient-bg left-line">
                <h2 class="display-6 fw-normal"><span class="fw-black">We're Startup</span><br>Creative Agency</h2>
                <p>If you want to have the most success when you are creating a homepage for your site, it is a good idea.</p>
                <div class="row g-4 mt-4">
                    <div class="col-12 col-lg-6 col-xl-6 dn-service-box text-center mb-5" *ngFor="let feature of features">
                        <div class="circle-box-xl bg-light-theme mb-3">
                            <i class="bi color-primary" [ngClass]="feature.icon"></i>
                        </div>
                        <h3>{{feature.title}}</h3>
                    </div>
                </div>
            </div>
        </div><!-- end row -->
    </div>
</div>
<!-- end About section -->

<!-- Facts section -->
<div class="section-md bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg')">
    <div class="container text-center">
        <div class="row g-4">
            <!-- Counter box 1 -->
            <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
                <h1 class="fw-semi-bold color-primary"><span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span>+</h1>
                <h4 class="fw-black color-dark">{{fact.desc}}</h4>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Facts section -->

<!-- Portfolio section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-4 heading-style-one">
                <hr class="gradient-bg left-line">
                <h2 class="display-6 fw-black">Our Portfolio</h2>
            </div>
        </div>
        <div class="row portfolio-grid g-2 g-lg-3 mrt-60">
        <!-- Portfolio box -->
        <div *ngFor="let work of works" class="col-12 col-md-4 portfolio-item">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img src="assets/images/portfolio/grid/{{work.img}}" alt="gallery-img">
                    </div>
                    <a routerLink="/portfolio-one"></a>
                    <div class="portfolio-title">
                        <div>
                            <h5 class="fw-normal">{{work.title}}</h5>
                            <span>{{work.category}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
<!-- end Portfolio section -->

<!-- Services section -->
<div class="section">
    <div class="hexagon-gradient-left shapes" data-opacity="0.3" [style.transform]="'rotate(' + rotationDegreeLeft + 'deg)'" style="transition: transform 0.5s ease-in-out; display: inline-block;"></div>
    <div class="triangle-light-blue shapes" data-opacity="0.2" [style.transform]="'rotate(' + rotationDegreeRight + 'deg)'" style="transition: transform 0.5s ease-in-out; display: inline-block;"></div>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-12 heading-style-two">
                <h2 class="display-6 fw-black">Our Services</h2>
            </div>
        </div>
        <div class="row align-items-center mrt-50">
            <div class="col-md-4 main-service-box text-center" *ngFor="let service of services">
                <i class="bi color-primary" [ngClass]="service.icon"></i>
                <h4>{{service.title}}</h4>
                <p>{{service.desc}}</p>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-1.jpg')">
    <div class="bg-overlay-gradient">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Team section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-12 heading-style-two">
                <h2 class="display-6 fw-black">Our Team</h2>
            </div>
        </div>
        <div class="row align-items-center mrt-50">
            <div class="col-md-3 col-sm-6 col-xs-12" *ngFor="let member of teamMembers">
                <div class="team-member-container gallery-image-hover">
                    <img [src]="member.image" class="img-responsive" [alt]="member.name">
                    <div class="member-caption">
                        <div class="member-description">
                            <div class="member-description-wrap">
                                <h4 class="member-title">{{ member.name }}</h4>
                                <p class="member-subtitle">{{ member.position }}</p>
                                <ul class="member-icons">
                                    <li class="social-icon">
                                        <a href="#"><i class="bi bi-facebook"></i></a>
                                    </li>
                                    <li class="social-icon">
                                        <a href="#"><i class="bi bi-twitter-x"></i></a>
                                    </li>
                                    <li class="social-icon">
                                        <a href="#"><i class="bi bi-instagram"></i></a>
                                    </li>
                                    <li class="social-icon">
                                        <a href="#"><i class="bi bi-linkedin"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- Testimonial section -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/main-bg-1.jpg')">
    <div class="bg-overlay-light">
        <div class="container z-index-1">
            <div class="row">
                <div class="col-12 col-lg-12 heading-style-two">
                    <h2 class="display-6 fw-black">Our Testimonials</h2>
                </div>
            </div>
            <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial pd-0">
                <ng-template carouselSlide *ngFor="let tes of testimonials">
                    <!-- Testimonial box -->
                    <div class="testimonial-item">
                        <div class="testimonial-content">
                            <div class="testimonial-content-in">
                                <div class="img">
                                    <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                                </div>
                                <h5>{{tes.name}}</h5>
                                <h6>{{tes.position}}</h6>
                                <p>{{tes.desc}}</p>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div><!-- end container -->
    </div>
</div>
<!-- end Testimonial section -->

<!-- Blogs section -->
<div class="section-lg pd-b-0">
    <div class="polygon-box shapes" data-opacity="0.2" [style.transform]="'rotate(' + rotationDegreeLeft + 'deg)'" style="transition: transform 0.5s ease-in-out; display: inline-block;"></div>
    <div class="circle-box shapes" data-opacity="0.2" [style.transform]="'rotate(' + rotationDegreeRight + 'deg)'" style="transition: transform 0.5s ease-in-out; display: inline-block;"></div>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-12 heading-style-two">
                <h2 class="display-6 fw-black">Our Blogs</h2>
            </div>
        </div>
        <div class="row align-items-center mrt-50">
            <div class="col-md-4" *ngFor="let post of posts">
                <div class="post">
                    <div class="post-img">
                        <img class="img-responsive" [src]="post.image" [alt]="post.title">
                    </div>
                    <div class="post-info">
                        <h3>
                            <a routerLink="/blog-grid">{{ post.title }}</a>
                        </h3>
                        <h6 [ngClass]="post.color">
                            {{ post.category }}
                        </h6>
                        <p>{{ post.time }}</p>
                        <a class="readmore" routerLink="/blog-grid">
                            <span>
                                Read More
                                <i class="eicon bi bi-arrow-right-short"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Blogs section -->
